export default __webpack_public_path__ + "static/Entenda0038-05dce5d969398ea438de359eaeab7781.jpg";